<template>
  <div :class="classes" :style="styles" @click="$_onDivClick">
    <slot>
      <i :class="`${$constants.CLASS_MAIN} ${$constants.PREFIX_ICON_CLASS}3x ${$constants.PREFIX_ICON_CLASS}arrow-up-bold-circle icon-gradient-primary`"></i>
    </slot>
  </div>
</template>
<script>
import * as constants from '../../utils/constants'
import { scrollTop } from '../../utils/assist'

const PREFIX_BACK_TOP_CLASS = `${constants.PREFIX_CLASS}back-top`

export default {
  props: {
    height: {
      type: Number,
      default: 400
    },
    bottom: {
      type: Number,
      default: 30
    },
    right: {
      type: Number,
      default: 30
    },
    duration: {
      type: Number,
      default: 1000
    }
  },
  data() {
    return {
      backTop: false
    }
  },
  computed: {
    classes() {
      return [
        PREFIX_BACK_TOP_CLASS,
        {
          [`${PREFIX_BACK_TOP_CLASS}--show`]: this.backTop
        }
      ]
    },
    styles() {
      return {
        bottom: `${this.bottom}px`,
        right: `${this.right}px`
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.$_handleScroll, false)
    window.addEventListener('resize', this.$_handleScroll, false)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.$_handleScroll, false)
    window.removeEventListener('resize', this.$_handleScroll, false)
  },
  methods: {
    $_handleScroll() {
      this.backTop = window.pageYOffset >= this.height
    },
    $_onDivClick() {
      const sTop = document.documentElement.scrollTop || document.body.scrollTop
      scrollTop(window, sTop, 0, this.duration)
      this.$emit('on-click')
    }
  }
}
</script>



// WEBPACK FOOTER //
// back2top.vue?3d8f85a1